<template>
  <TermsOfUseTarm  v-on:validate="validate($event)"></TermsOfUseTarm>
  <!-- <TermsOfUseDoctor v-else-if="userRule == 'medico'" v-on:validate="validate($event)"></TermsOfUseDoctor>
  <TermsOfUseAdmin v-else v-on:validate="validate($event)"></TermsOfUseAdmin> -->
</template>

<script>
import TermsOfUseTarm from '../../components/terms_of_use/terms_tarm'
//import TermsOfUseDoctor from '../../components/terms_of_use/terms_doctor'
//import TermsOfUseAdmin from '../../components/terms_of_use/terms_admin'
export default {
  name:"TermsOfUse",
  components:{
    TermsOfUseTarm/* ,TermsOfUseDoctor,TermsOfUseAdmin */
  },
  data: () => ({
    
  }),
    
  computed:{
    userRule(){
      var rule = this.$store.getters.userRule
      return rule
    }
  },
  methods: {
    validate(validateForm) {
      if(validateForm){
          this.$store.dispatch('acceptedTerm',validateForm)
          this.$router.push('/')
      }
    }
  }
};
</script>

<style scoped>
</style>